import { render, staticRenderFns } from "./FixedPriceList.vue?vue&type=template&id=6211db56"
import script from "./FixedPriceList.vue?vue&type=script&lang=js"
export * from "./FixedPriceList.vue?vue&type=script&lang=js"
import style0 from "./FixedPriceList.vue?vue&type=style&index=0&id=6211db56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports